<ui-section>
  <ui-block>
    <ui-panel width="fill" class="platform-lookup-metadata-admin" panelTitle="Lookup & Metadata" title="Lookup & Metadata" [subtitle]="pagePanelSubtitle"
      [panelHeaderConfig]="pagePanelHeaderConfig" (buttonClick)="onPagePanelHeaderButtonClick($event)">
      <div class="message-box success" *ngIf="successMessage()" role="status" aria-live="polite">
        {{ successMessage() }}
      </div>

      <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
        <p>{{ error.title }}</p>
        <ul>
          <li *ngFor="let message of error.messages">{{ message }}</li>
        </ul>
        <div class="error-meta" *ngIf="error.problemCode || error.issueCodes.length > 0 || error.correlationId">
          <span *ngIf="error.problemCode">Problem code: {{ error.problemCode }}</span>
          <span *ngIf="error.issueCodes.length > 0">Issue codes: {{ error.issueCodes.join(', ') }}</span>
          <span *ngIf="error.correlationId">Correlation ID: {{ error.correlationId }}</span>
        </div>
      </div>

      <div class="lm-shell">
        <ui-grid class="catalog-panel" [dsConfig]="entryGridConfig" [agGridOptions]="entryAgGridOptions"
          [defaultColDef]="entryGridDefaultColDef" [panelHeaderConfig]="entryPanelHeaderConfig" [showPanelHeader]="true"
          [reloadOnChangeTrigger]="entryGridReloadTrigger()"></ui-grid>

        <ui-panel class="detail-panel-host" [panelTitle]="detailPanelTitle()" [title]="detailPanelTitle()">
          <div class="detail-panel__body" aria-label="Legacy terminology detail">
            <div class="detail-panel__header">
              <div>
                <p class="detail-panel__subtitle">
                  {{ detailSubtitle() }}
                </p>
              </div>

              <div class="detail-panel__status" *ngIf="selectedEntry() as entry">
                <span class="status-pill">{{ toStatusLabel(entry.versionStatusCode) }}</span>
                <span>{{ entry.configurationCode }} / {{ entry.versionCode }}</span>
              </div>
            </div>

            <ng-container *ngIf="selectedEntry() as entry; else noSelection">
              <ng-container *ngIf="isSelectedTerminology(); else editableMetadata">
                <div class="compatibility-note" role="note">
                  <strong>Compatibility record</strong>
                  <span>{{ entryEditBlockedReason() }}</span>
                  <span>This value may reflect the last synchronized legacy row; the Terminology workspace is authoritative.</span>
                </div>

                <dl class="reference-grid" aria-label="Legacy terminology properties">
                  <div class="reference-field reference-field--wide">
                    <dt>Published wording</dt>
                    <dd>{{ entry.displayText }}</dd>
                  </div>
                  <div class="reference-field reference-field--wide">
                    <dt>Token</dt>
                    <dd class="reference-code">{{ entry.code }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Legacy row ID</dt>
                    <dd>{{ entry.id }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Configuration</dt>
                    <dd class="reference-code">{{ entry.configurationCode }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Configuration version ID</dt>
                    <dd>{{ entry.configurationVersionId }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Version</dt>
                    <dd>{{ entry.versionCode }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Lifecycle state</dt>
                    <dd>{{ toStatusLabel(entry.versionStatusCode) }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Runtime active</dt>
                    <dd>{{ entry.isActive ? 'Yes' : 'No' }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Scope type</dt>
                    <dd>{{ entry.scopeTypeCode || 'Unspecified' }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Scope key</dt>
                    <dd class="reference-code">{{ entry.scopeKey || 'All scopes' }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Effective start</dt>
                    <dd>{{ entry.effectiveStartUtc | date:'medium' }}</dd>
                  </div>
                  <div class="reference-field">
                    <dt>Effective end</dt>
                    <dd>{{ entry.effectiveEndUtc ? (entry.effectiveEndUtc | date:'medium') : 'Open-ended' }}</dd>
                  </div>
                </dl>

                <div class="workspace-handoff">
                  <div>
                    <strong>Continue in the governed workspace</strong>
                    <p>Opens the exact definition by token and configuration with draft, impact, release, history, and health tools.</p>
                  </div>
                  <ui-button buttonText="Open in Terminology" [disabled]="!canOpenSelectedTerminology()"
                    (click)="openSelectedTerminology()"></ui-button>
                </div>
              </ng-container>
            </ng-container>

            <ng-template #editableMetadata>
              <ng-container *ngIf="selectedDomain()">
                <div class="inline-note" *ngIf="entryEditBlockedReason()">{{ entryEditBlockedReason() }}</div>
                <ui-form #entryForm [config]="entryFormConfig" [(formValues)]="entryFormValues"
                  [disabled]="isSaving() || !!entryEditBlockedReason()" [showFormErrors]="false"></ui-form>
                <ui-button-group class="form-actions" [buttonsConfig]="entryFormActionButtons()"
                  (buttonClick)="onEntryFormActionButtonClick($event)"></ui-button-group>
              </ng-container>
            </ng-template>

            <ng-template #noSelection>
              <div class="empty-state">
                Select a legacy terminology row to inspect its compatibility identity and open the authoritative versioned definition.
              </div>
            </ng-template>
          </div>
        </ui-panel>
      </div>
    </ui-panel>
  </ui-block>
</ui-section>
